// Firebase config file (firebaseConfig.ts)
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import config from '../config';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: config.firebase.api_key,
    authDomain: config.firebase.auth_domain,
    projectId: config.firebase.project_id,
    storageBucket: config.firebase.storage_bucket,
    messagingSenderId: config.firebase.sender_id,
    appId: config.firebase.app_id
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

const storage = getStorage(app);

export { storage };